import React, {useEffect} from 'react';
import './usage-agreement-style.scss';
import {ReactComponent as LogoFooter} from 'assets/images/turkish-airlines-logo/logo-turkishairlines.svg';
import {useTranslation} from "react-i18next";
import parse from "html-react-parser";

const UsageAgreementComponent = (props) => {
    const {t} = useTranslation();
    const {visible, title, description, showCancel, showConfirm, cancel, confirm} = props;

    useEffect(() => {
        if (visible) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';
    }, [visible])

    return (
        visible && (<div className={visible ? 'visible-fadeIn' : ''}>
            <div className="usage-agreement-opacity" onClick={() => cancel()}></div>
            <div className="usage-agreement-root">
                <div className="usage-agreement-root-logo">
                    <LogoFooter/>
                </div>
                <div className="usage-agreement-description">
                    <p className="usage-agreement-title">{title}</p>
                    <div className="usage-agreement-content">
                        <p className="usage-agreement-content-text">
                            <br/>{parse(description !== undefined ? description?.replaceAll("\n", "<br/>") : '')}<br/><br/>
                        </p>
                    </div>
                </div>
                <div className="usage-agreement-btn">
                    {showCancel && <button className="usage-agreement-cancel"
                                           onClick={() => cancel()}>{t('usage_aggreement.cancel')}</button>}
                    {showConfirm && <button className="usage-agreement-confirm"
                                            onClick={() => confirm()}>{t('usage_aggreement.confirm')}</button>}
                </div>
            </div>
        </div>)
    );
};

export default UsageAgreementComponent;

